import { ReactNode } from 'react';
import { AlertCircle } from 'lucide-react';

export interface FormFieldProps {
  label?: ReactNode;
  htmlFor?: string;
  helper?: ReactNode;
  error?: ReactNode;
  required?: boolean;
  children: ReactNode;
  className?: string;
}

/**
 * Wrapper dla pól formularza. Daje consistent spacing, powiązanie label<->input
 * przez htmlFor, wyświetlanie helper text lub error message (error ma priorytet).
 *
 * <FormField label="Email" htmlFor="email" error={errors.email}>
 *   <Input id="email" type="email" />
 * </FormField>
 */
export function FormField({
  label,
  htmlFor,
  helper,
  error,
  required,
  children,
  className,
}: FormFieldProps) {
  return (
    <div className={['space-y-1.5', className].filter(Boolean).join(' ')}>
      {label && (
        <label
          htmlFor={htmlFor}
          className="block text-xs font-medium text-text-secondary"
        >
          {label}
          {required && <span className="text-danger ml-1" aria-label="wymagane">*</span>}
        </label>
      )}
      {children}
      {error ? (
        <p className="flex items-start gap-1.5 text-xs text-danger" role="alert">
          <AlertCircle className="w-3.5 h-3.5 shrink-0 mt-0.5" />
          <span>{error}</span>
        </p>
      ) : helper ? (
        <p className="text-xs text-text-muted">{helper}</p>
      ) : null}
    </div>
  );
}
